import axios from 'axios';

const TOKEN_KEY = 'zone_portal_token';

export const getPortalToken = () => localStorage.getItem(TOKEN_KEY);
export const setPortalToken = (token) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
};
export const clearPortalToken = () => localStorage.removeItem(TOKEN_KEY);

const portalApi = axios.create({
  baseURL: '/api/portal',
  headers: { 'Content-Type': 'application/json' }
});

portalApi.interceptors.request.use((config) => {
  const token = getPortalToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

portalApi.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearPortalToken();
      if (typeof window !== 'undefined' && !window.location.pathname.startsWith('/portal/auth')) {
        window.location.replace('/portal');
      }
    }
    return Promise.reject(error);
  }
);

export default portalApi;
